import { parse } from "path";

const formatCurrency = (number) => {
  number = number.toString().replace(",", "");
  // number=number.toString()
  if (number >= 0) {
    return "$" + formatNumber(Math.abs(number).toFixed(2));
  } else {
    return "-$" + formatNumber(Math.abs(number).toFixed(2));
  }
};

const formatNumber = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
const formatCurrencyToFixed = (number) => {
  return formatNumber(Math.abs(number).toFixed(2));
};
const formatCurrencyToFixedZero = (number) => {
  return formatNumber(Math.abs(number).toFixed(0));
};

export {
  formatCurrency,
  formatNumber,
  formatCurrencyToFixed,
  formatCurrencyToFixedZero,
};
